import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import { APP_SIGNIN } from './components/shared'

import HomePage from './pages/HomePage'
import CaseStudiesPage from './pages/CaseStudiesPage'
import LegalPage from './pages/LegalPage'
import PricingPage from './pages/PricingPage'
import RefundPage from './pages/RefundPage'
import SignupSoonPage from './pages/SignupSoonPage'

/* Launch fixes 1: /login and /signin go to the app's sign-in page */
function ToAppSignin() {
  useEffect(() => { window.location.replace(APP_SIGNIN) }, [])
  return <p style={{ padding: '140px 24px', textAlign: 'center' }}>Opening the sign-in page: <a href={APP_SIGNIN}>sign in to SerpDesk</a>.</p>
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          {/* L20: the privacy policy and terms, out of the catch-all (Google's OAuth verification links both) */}
          <Route path="/privacy" element={<LegalPage doc="privacy" />} />
          <Route path="/terms" element={<LegalPage doc="terms" />} />
          {/* Launch fixes 1 (2026-10-19): pricing, refunds and cancellation, and the trial's opening-soon page */}
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/refund" element={<RefundPage />} />
          <Route path="/signup" element={<SignupSoonPage />} />
        </Route>

        <Route path="/login" element={<ToAppSignin />} />
        <Route path="/signin" element={<ToAppSignin />} />

        {/* Stale routes from the old SaaS framing: redirect to home */}
        {/* FE1 (2026-10-28, the PM's choice on screen): the seven product pages described the May platform, so they
            open Home too; their files are kept, unrouted */}
        {['/intelligence', '/optimize', '/content', '/deploy', '/results', '/links', '/competitors'].map((p) => (
          <Route key={p} path={p} element={<Navigate to="/" replace />} />
        ))}
        <Route path="/technical" element={<Navigate to="/" replace />} />
        <Route path="/cro" element={<Navigate to="/" replace />} />
        <Route path="/start" element={<Navigate to="/" replace />} />

        {/* Catch-all 404 → home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
